export class RestClient {
  constructor(baseUrl, shop, authToken, getNewAuthTokenFunction, customRequestHeaders) {
    this.baseUrl = baseUrl;
    this.shop = shop;
    this.authToken = authToken;
    this.getNewAuthTokenFunction = getNewAuthTokenFunction;
    this.customRequestHeaders = customRequestHeaders;
  }
  async get(endpoint) {
    const requestMethod = 'GET';
    let response = await this.invokeRequest(`${this.baseUrl}/${endpoint}`, requestMethod);
    return await response.json();
  }
  async put(endpoint, data) {
    const requestMethod = 'PUT';
    const body = JSON.stringify(data);
    let response = await this.invokeRequest(`${this.baseUrl}/${endpoint}`, requestMethod, body);
    return response;
  }
  async postData(endpoint, data) {
    const requestMethod = 'POST';
    const body = JSON.stringify(data);
    let response = await this.invokeRequest(`${this.baseUrl}/${endpoint}`, requestMethod, body);
    return await response.json();
  }
  async invokeRequest(url, requestMethod) {
    let body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    const request = {
      method: requestMethod,
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Shop-Context': `${this.shop}`,
        'Request-Id': this.newGuid()
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer'
    };
    // Add custom request headers specified during construction
    if (this.customRequestHeaders !== undefined) {
      for (let headerKey in this.customRequestHeaders) {
        let headerValue = this.customRequestHeaders[headerKey];
        request.headers[headerKey] = headerValue;
      }
    }
    // Add Bearer auth header specified during construction
    if (this.authToken !== undefined) {
      request.headers['Authorization'] = `Bearer ${this.authToken}`;
    }
    // Add body to request
    if (body !== undefined) {
      request['body'] = body;
    }
    // Invoke request
    let response = await fetch(url, request);
    // If response is a 401 error, attempt to re-authenticate first and then retry the requests once
    if (response.status === 401 && this.getNewAuthTokenFunction !== undefined) {
      this.authToken = await this.getNewAuthTokenFunction();
      request.headers['Authorization'] = `Bearer ${this.authToken}`;
      request.headers['Request-Id'] = this.newGuid();
      response = await fetch(url, request);
    }
    if (response.status >= 400) {
      throw new Error(`${requestMethod} request to ${url} failed with response: ${response.status} - ${response.statusText}`);
    }
    return response;
  }
  newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = Math.random() * 16 | 0; // eslint-disable-line no-bitwise
      const v = c == 'x' ? r : r & 0x3 | 0x8; // eslint-disable-line no-bitwise, eqeqeq
      return v.toString(16);
    });
  }
}